import { fg } from '@atlassian/jira-feature-gating';

const isProjectFieldsGaFastFollowsEnabled = {
	get(): boolean {
		return fg('project_fields_page_for_tmp_-_ga_fast_follows');
	},
};
export default isProjectFieldsGaFastFollowsEnabled;
